import './style.css'
import React, { Component } from 'react'
import { SpinnerIcon } from 'components/Utils/Icons'

class Loading extends Component {
  render() {
    return (
      <div className="flexbox flexbox-align-center flexbox-centered font-weight-large transition">
        <SpinnerIcon className="margin-small collection-input-spinner-rotating margin-top-huge" />
      </div>
    )
  }
}

export default Loading
